import { PlaceholderProps, components } from "react-select";

import styles from "./select-layout.module.scss";

const Placeholder = (props: PlaceholderProps) => (
  <components.Placeholder
    {...props}
    innerProps={{ ...props.innerProps, id: styles.placeholder }}
  />
);

export default Placeholder;
